module.exports = __webpack_public_path__ + "app/widgets/long-task-progress-3Tl4VTtN.html";